import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class MarketPerformanceSubscription extends Model {
  [Type] = 'market-performance/subscription' as const;

  @attr('string') declare currencyCode: string;
  @attr('string') declare hotelName: string;
}
